module.exports = __webpack_public_path__ + "static/media/avatar-5.3e35c39b.jpg";